<template>
  <div class="filtter-padding">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="title" color="grey" dense>
          {{title}}
          <template v-slot:actions>
            <v-icon color="white"> $expand </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters v-if='dataFilter'>
            <div v-for="data in dataFilter" :key="data.id">
            <v-col  cols="data.div" sm="data.div">
              <v-autocomplete
                class="spaceInput"
                :v-model="data.model"
                :append-icon="data.icon"
                :label="data.label"
                :items="data.stateValue"
              ></v-autocomplete>
            </v-col>
            </div>
            <v-col :cols="btnDiv" :sm="btnDiv" right class="d-flex justify-center mb-3">
              <v-btn small class="mx-2 mt-auto" elevation="0" :loading="load" :text="typeButton === 'text'" :outlined="typeButton === 'outlined'" @click="execute" :color="colorBtn || 'blueKonect'">
                <v-icon v-if="icon && alignIcon" left>{{ icon }}</v-icon>
                {{ text }}
                <v-icon v-if="icon && !alignIcon" right>{{ icon }}</v-icon>
            </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
const props = {
  text: {
    default: "Consultar",
    type: String,
  },
  onClick: Function,
  icon: {
    default: "mdi-magnify",
    type: String,
  },
  colorBtn: String,
  typeButton: {
    default: "outlined",
    type: String,
  },
  alignIcon: {
    default: false,
    type: Boolean,
  },
  load: {
    default: false,
    type: Boolean,
  },
  title: {
    default: 'Filtros',
    type: String
  },
  btnDiv: {
    default: 4,
    type: Number

  },
  dataFilter: Array
};

export default {
  methods: {
    execute() {
      if (this.onClick) {
        this.onClick();
      }
    },
  },
  props: props,
};
</script>

<style scoped>
.spaceInput{
  margin-left:5% ;
}
</style>
